// extracted by mini-css-extract-plugin
export default {"containerError":"error404_containerError__f5GPp"};